@if (withShell) {
<astral-field-shell
  [control]="control"
  [forId]="resolvedInputId"
  [helpText]="helpText"
  [label]="resolvedLabel"
  [readonly]="resolvedReadonly"
  [disabled]="resolvedDisabled"
  [showRequiredMarker]="showRequiredMarker"
>
  <div class="astral-input__layout" [class.astral-input__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
</astral-field-shell>
} @else {

<!-- Display a "bare" input-element without a shell. I added this in case we want input fields in cramped spaces like list-view cells. This may be redundant. /Atlan -->
  <div class="astral-input__layout" [class.astral-input__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
}

<ng-template #inputTemplate>
  <div
    class="astral-input"
    [class.astral-input--readonly]="resolvedReadonly"
    [class.astral-input--disabled]="resolvedDisabled"
    [class.astral-input--focused]="isFocused"
  >
    <div class="astral-input__actions">
      @if (showClearOthers) {
        <astral-field-action
        icon="clearOthers"
        titleKey="COMMON.CLEAR_OTHER_FILTERS"
        ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
        (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
        icon="clear"
        titleKey="COMMON.CLEAR"
        ariaLabelKey="COMMON.CLEAR"
        (click)="clearInput()"
        ></astral-field-action>
      }

      @if (showPasswordToggle) {
        <astral-field-action
        [icon]="passwordVisible ? 'eyeSlash' : 'eye'"
        [titleKey]="passwordVisible ? 'COMMON.HIDE_PASSWORD' : 'COMMON.SHOW_PASSWORD'"
        [ariaLabelKey]="passwordVisible ? 'COMMON.HIDE_PASSWORD' : 'COMMON.SHOW_PASSWORD'"
        (click)="togglePasswordVisibility()"
        ></astral-field-action>
      }

      @if (showCallAction) {
        <astral-field-action
        icon="call"
        titleKey="COMMON.CALL"
        ariaLabelKey="COMMON.CALL"
        [href]="phoneHref"
        ></astral-field-action>
      }

      @if (showEmailAction) {
        <astral-field-action
        icon="email"
        titleKey="COMMON.EMAIL"
        ariaLabelKey="COMMON.EMAIL"
        (click)="sendEmail()"
        ></astral-field-action>
      }
    </div>

    <div class="astral-input__control-shell" [class.astral-input__control-shell--readonly]="resolvedReadonly">
      @if (resolvedReadonly) {
        <span class="astral-input__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      @if (control && !(resolvedReadonly && translateValue)) {
      <input
        #input
        astralFieldAccessibility
        [astralFieldControl]="accessibilityControl ?? control"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        class="astral-input__control"
        [formControl]="control"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [type]="resolvedInputType"
        [attr.inputmode]="resolvedInputMode"
        [attr.pattern]="integerOnly ? '[0-9]*' : null"
        [attr.max]="max ?? null"
        [attr.min]="min ?? null"
        [attr.step]="step ?? null"
        [attr.autocomplete]="autocomplete"
        [attr.placeholder]="placeholderText ? (placeholderText | translate) : null"
        [readonly]="resolvedReadonly ? true : null"
        [required]="control?.required ? true : null"
        [class.astral-input__control--center]="textAlignCenter"
        (keydown)="prepareMaskedSecretForEditing($event)"
        (beforeinput)="handleIntegerBeforeInput($event)"
        (paste)="handlePaste($event)"
        (input)="handleIntegerInput($event)"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
      />
      } @else {
        <input
          #input
          astralFieldAccessibility
          [astralFieldControl]="accessibilityControl ?? control"
          [astralFieldHelpText]="helpText"
          [astralFieldInputId]="resolvedInputId"
          class="astral-input__control"
          [attr.id]="resolvedInputId"
          [attr.name]="resolvedInputName"
          [type]="resolvedInputType"
          [attr.inputmode]="resolvedInputMode"
          [attr.pattern]="integerOnly ? '[0-9]*' : null"
          [attr.max]="max ?? null"
          [attr.min]="min ?? null"
          [attr.step]="step ?? null"
          [attr.autocomplete]="autocomplete"
          [attr.placeholder]="placeholderText ? (placeholderText | translate) : null"
          [value]="translateValue ? (resolvedStringValue | translate) : resolvedStringValue"
          [readonly]="resolvedReadonly ? true : null"
          [disabled]="resolvedDisabled ? true : null"
          [class.astral-input__control--center]="textAlignCenter"
          (keydown)="prepareMaskedSecretForEditing($event)"
          (beforeinput)="handleIntegerBeforeInput($event)"
          (paste)="handlePaste($event)"
          (input)="handleIntegerInput($event)"
          (focus)="handleFocus()"
          (blur)="handleBlur()"
        />
      }
    </div>
  </div>
</ng-template>

<!-- This is where supplemental label text is rendered. e.g. "[input] per month" /Atlan -->
<ng-template #supplementalLabelTemplate>
  @if (resolvedSupplementalLabel) {
    <span class="astral-input__supplemental-label">
      {{ resolvedSupplementalLabel | translate }}
    </span>
  }
</ng-template>
